import { GetTeamDetailsDocument } from './use-team.generated'

export default function () {
  const isFetching = ref(false)

  const { execute } = useQuery({
    query: GetTeamDetailsDocument,
    fetchOnMount: false,
    // TODO: Change the line below to `({ id }) => !id` if/when they merge the
    // following PR in villus: https://github.com/logaretm/villus/pull/213
    skip: () => !isFetching.value,
    tags: ['teams'],
  })

  async function fetchTeam(id: string) {
    isFetching.value = true
    const response = await execute({ variables: { id } })
    isFetching.value = false

    const team = response.data?.organization.team
    return {
      name: team?.name ?? '',
      provider: team?.provider ?? null,
      parent: team?.parent ?? { id: '', name: '' },
    }
  }

  return { fetchTeam, isFetching }
}
